import { MouseSensor, KeyboardSensor } from "@dnd-kit/core";

export class CustomMouseSensor extends MouseSensor {
    static activators = [
        {
            eventName: "onMouseDown" as const,
            handler: ({ nativeEvent }: { nativeEvent: MouseEvent }) => {
                if (nativeEvent.target instanceof SVGElement) return false;
                if (nativeEvent.target instanceof HTMLElement) return shouldHandleEvent(nativeEvent.target)
                return true;
            },
        },
    ];
}
export class CustomKeyboardSensor extends KeyboardSensor {
    static activators = [
        {
            eventName: "onKeyDown" as const,
            handler: ({ nativeEvent }: { nativeEvent: KeyboardEvent }) => {
                if (nativeEvent.target instanceof HTMLElement) return shouldHandleEvent(nativeEvent.target)
                return true;
            },
        },
    ];
}

function shouldHandleEvent(element: HTMLElement): boolean {
    let cur: HTMLElement | null = element;

    while (cur) {
        if (cur.dataset && cur.dataset.noDnd !== undefined) {
            return false;
        }
        cur = cur.parentElement;
    }

    return true;
}